import React from 'react';
import FormCheckbox from '../../Form/FormCheckbox';
import { SearchParams } from '../types';
import i18n from '../../i18n';

type SearchFormFilteringProps = {
  featuredAreaCodes: string[];
  query: SearchParams,
  onChangeQuery: (query: SearchParams) => void
}

const SearchFormFiltering: React.FC<SearchFormFilteringProps> = ({ featuredAreaCodes, query, onChangeQuery }) => {
  const onChangeHoshinoResort = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChangeQuery({
      ...query,
      forHoshinoResort: e.target.checked ? true : null
    });
  };

  const onChangeSkiInOut = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChangeQuery({
      ...query,
      skiInOut: e.target.checked ? true : null
    });
  }

  const onChangeHotSpring = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChangeQuery({
      ...query,
      hotSpring: e.target.checked ? true : null
    });
  }

  const onChangeAreas = (e: React.ChangeEvent<HTMLInputElement>, areaCode: string) => {
    const newAreas = e.target.checked
      ? [...query.areaCodes, areaCode]
      : query.areaCodes.filter((area) => area !== areaCode);

    onChangeQuery({
      ...query,
      areaCodes: newAreas
    });
  }

  return (
    <div className='border d-flex flex-column p-3'>
      <p className='text-center font-weight-bold'>{i18n.t('stay_packages.hotels.index.filter')}</p>
      <p className='font-weight-bold'>{i18n.t('stay_packages.hotels.index.filter_by_popular_1')}{i18n.t('stay_packages.hotels.index.filter_by_popular_2')}</p>
      <FormCheckbox
        id='checkbox-hoshino-resorts'
        label={i18n.t('stay_packages.shared.hoshino_resort')}
        checked={query.forHoshinoResort}
        onChange={onChangeHoshinoResort}
      />
      <FormCheckbox
        id='checkbox-ski-in-out'
        label={i18n.t('stay_packages.hotels.index.ski_in_ski_out')}
        checked={query.skiInOut}
        onChange={onChangeSkiInOut}
      />
      <FormCheckbox
        id='checkbox-hot-spring'
        label={i18n.t('stay_packages.hotels.index.hot_spring_available')}
        checked={query.hotSpring}
        onChange={onChangeHotSpring}
      />
      {/* <hr />
      <p className='font-weight-bold'>{i18n.t('stay_packages.hotels.index.filter_by_area')}</p>
      {featuredAreaCodes.map((code) => {
        return (
          <FormCheckbox
            id={code}
            key={code}
            label={i18n.t(`areas.${code}`)}
            onChange={(e) => onChangeAreas(e, code)}
          />
        )
      })} */}
    </div>
  );
}

export default SearchFormFiltering;
